import React from 'react'
import mainimage from "../../images/toperbackgroundimage.svg"
import newRequest from '../../utils/newRequest';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import imageLiveUrl from '../../utils/urlConverter/imageLiveUrl';
// import aboutgs1ksa from "../../images/secondsimage.png"

function Mainsection() {
  const navigate=useNavigate()
  const { t, i18n } = useTranslation();
    const { isLoading, error, data: headerData } = useQuery("fetchAllheader", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllfirst_container");
    return response?.data.filter(item => item.status === 1) || [];
  }
    return (
      <>
        <div
          // className="mt-10 relative h-auto"
          className=" w-full mt-10  bg-cover bg-center"
          // style={{ backgroundImage: `url(${mainimage})` }}
        >
          {/* <img
            src={mainimage}
            className="w-full h-[80] object-cover"
            alt="Slide 1"
          /> */}

          {isLoading ? (
            <div className="flex justify-center items-center h-[420px]">
              <p>Loading....</p>
            </div>
          ) : error ? (
            ""
          ) : (
            headerData &&
            headerData.map((item) => (
              <div className={`top-24 `}>
                <div className={`w-full px-4 md:px-20 text-left`}>
                  <div
                    className={`flex flex-wrap justify-center items-center sm:flex-col ${
                      i18n.language === "ar"
                        ? "flex-row-reverse md:flex-row-reverse"
                        : "flex-row md:flex-row"
                    }`}
                  >
                    <div
                      className={`w-full  md:w-2/4 sm:py-0 py-4 sm:px-0 px-3 mt-6 ${
                        i18n.language === "ar" ? "text-right" : "text-left "
                      }`}
                    >
                      <p className="mb-3 font-bold text-xl font-sans">
                        {/* {item.title} */}
                        {i18n.language === "ar" ? item.title_ar : item.title}
                      </p>
                      <h2
                        //   className="text-2xl font-sans text-secondary font-semibold mb-3 mt-3"
                        className="mb-5 font-extrabold text-[2.625rem] leading-[calc(50/42)] tracking-[-1px] text-[#1d2331] font-lato"
                      >
                        {i18n.language === "ar"
                          ? item.description_ar
                          : item.description}
                      </h2>
                      <p className="font-sans text-[#596175] text-xl">
                        {i18n.language === "ar"
                          ? item.caption_ar
                          : item.caption}
                      </p>
                      <button
                        onClick={() => navigate(item.url)}
                        className="bg-[#f0452b] my-20 text-white mx-3 px-8 border border-[#f0452b] hover:bg-[#2b4892] hover:border-[#2b4892]  py-2 text-lg font-bold  rounded-md transition-all duration-300  transform "
                      >
                       {t(`${item.button}`)}
                      </button>
                      {/* <p className="mt-30">(No Credit Card Required)</p> */}
                    </div>

                    <div className={`w-full md:w-1/2`}>
                      <img
                        src={imageLiveUrl(item?.image) || ""}
                        className="h-auto sm:w-[100%] w-full object-contain"
                        alt="Header image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </>
    );
}

export default Mainsection